module.exports = __webpack_public_path__ + "static/img/Bachelor_010311.7ab7c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010311.jpg
// module id = 147
// module chunks = 0